import React from 'react';
import type { CalendarDay } from '@abs/shared-types';
import { CalendarDayCell } from './CalendarDay';

export interface CalendarMonthProps {
  days: CalendarDay[];
}

const WEEKDAY_HEADERS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function CalendarMonth({ days }: CalendarMonthProps): React.ReactElement {
  return (
    <div className="calendar-month" role="grid" aria-label="Calendar">
      <div className="calendar-month__header" role="row">
        {WEEKDAY_HEADERS.map((d) => (
          <div key={d} className="calendar-month__weekday" role="columnheader">
            {d}
          </div>
        ))}
      </div>
      <div className="calendar-month__body">
        {days.map((day) => (
          <CalendarDayCell key={day.date} day={day} />
        ))}
      </div>
    </div>
  );
}
